<div class="demo-full-width margin-top" [formGroup]="group">
    <button type="submit" mat-raised-button color="primary" [innerHtml]="field.label| HTMLFormatter"></button>
</div>